
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"signature"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.077 10.637l-.885 3.535 3.536-.884 5.303-5.303-2.651-2.652-5.303 5.304zm11.048-5.745l.884.884a1.25 1.25 0 010 1.767l-2.759 2.76m-1.219-2.318l3.094-3.093a1.25 1.25 0 000-1.768l-.884-.884a1.25 1.25 0 00-1.768 0L12.38 5.333","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.75 13.124H1.875a1.25 1.25 0 00-1.25 1.25v2.5a1.25 1.25 0 001.25 1.25h16.25a1.25 1.25 0 001.25-1.25v-2.5a1.25 1.25 0 00-1.25-1.25H13.75","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    